import {Component} from 'react';
import "../css/components/reportRowAction.css"

export interface RowAction<T> {
    displayValue: string;
    action?: (item: T) => void;
    shouldShowAction?: (item: T) => boolean;
}

interface ReportRowActionProps<T> {
    actions: RowAction<T>[];
    item: T;
}

interface ReportRowActionState {
    show: boolean;
}

class ReportRowAction<T = unknown> extends Component<ReportRowActionProps<T>, ReportRowActionState> {
    private mounted = false;

    constructor(props: ReportRowActionProps<T>) {
        super(props);

        this.state = {
            show: false
        };
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false
        document.body.removeEventListener('click', this.hideOptions);
    }

    showOptions = () => {
        if(this.mounted) {
            this.setState({show: true});
        }

        document.body.addEventListener('click', this.hideOptions, true);
    };

    selectAction = (option: RowAction<T>, item: T) => {
        if (option && typeof option.action === 'function') {
            option.action(item);
        }
    };

    hideOptions = () => {
        if(this.mounted) {
            this.setState({show: false});
        }

        document.body.removeEventListener('click', this.hideOptions);
    };


    render() {
        const visibleActions = this.props.actions.filter(action => {
            return !action.shouldShowAction || action.shouldShowAction(this.props.item);
        });
        return (
            <div>
                {
                    visibleActions.length > 0 ?
                        <div className='ss-row-action'>

                            <img className='ss-row-action-icon'
                                 onClick={this.showOptions}
                                 src="https://static.secur.space/app-images/ellipses-icon.png"
                                 alt="row-action"/>

                            <div className={this.state.show ? "ss-action-options-visible" : "ss-action-options-hidden"}>
                                <ul className="ss-action-list">
                                    {
                                        visibleActions.map((action, index) =>
                                            <li key={index}
                                                className={(!action.shouldShowAction || action.shouldShowAction(this.props.item)) ? "ss-action-item" : "hidden"}
                                                onClick={() => this.selectAction(action, this.props.item)}>
                                                {action.displayValue}
                                            </li>
                                        )

                                    }
                                </ul>
                            </div>
                        </div>
                        :
                        ''
                }
            </div>
        );
    }
}

export default ReportRowAction;
